import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import { ResSplitOrders } from "./splitOrders";

export const apiGroupOrders = async (groupId: ZUid, data: ResSplitOrders) => {
  await rest.post(apiObjUrl(`/groups/${groupId}/order`), data);
};

export const apiObjectOrders = async (objectId: ZUid, data: ResSplitOrders) => {
  await rest.post(apiObjUrl(`/objects/${objectId}/order`), data);
};

export const apiValueOrders = async (
  groupId: ZUid,
  valueId: ZUid,
  data: ResSplitOrders,
) => {
  await rest.post(
    apiObjUrl(`/groups/${groupId}/values/${valueId}/order`),
    data,
  );
};
